import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import { getNodesHash, updateNode, fetchNode, fetchNodes } from '../../modules/nodes';
import { checkACL } from '../acl/Config';
import { isNumber, isEmpty } from '../settings/form/ErrorChecking';
import { getAllNetworkInterfaces } from '../../utils/networkUtils';

import HeaderContainer from '../settings/form/HeaderContainer';
import InfoContainer from '../settings/form/InfoContainer';
import FormContainer from '../settings/form/FormContainer';
import LabelContainer from '../settings/form/LabelContainer';

const URL = "/dashboard/settings/devices/anchor_config";
const ANCHOR_PROPS = {
  anchor: "", hardware_id: "", nid: "", channel: "", mcs: "", nss: "", obw: "", payload_length: "", tx_power: "", mode: "", npkt: "",
  anch_alarm: "", anch_heartbeat: "", burst_timeout: "", loc_min_anch: "", loc_max_anch: "", addr: "", name: "", validate: true};

const MAVS2_PROPS = {
  mavs2_addr: "", mavs2_nid: "", mavs2_channel: "", mavs2_mcs: "", mavs2_nss: "", mavs2_obw: "", mavs2_payload_length: "",
  mavs2_tx_power: "", mavs2_mode: "", mavs2_npkt: "", mavs2_anch_alarm: "", mavs2_anch_heartbeat: "",
  mavs2_burst_timeout: "", mavs2_loc_min_anch: "", mavs2_loc_max_anch: "", mavs2_name: ""};

const EditAnchorConfig = (props) => {
  const [id, setId] = useState(null);
  const [anchor, setAnchor] = useState(null);
  const [config, setConfig] = useState(ANCHOR_PROPS);
  const [mavs2Config, setMavs2Config] = useState(MAVS2_PROPS);
  const [hasMavs2, setHasMavs2] = useState(false);
  const [error, setError] = useState(ANCHOR_PROPS);
  const [disable_save, setDisable_save] = useState(false);

  useEffect(()=> {
    if (props.match.params.id === "undefined" ) { return; }
    if (props.match.params.id === id) { return; }

    console.log("useEffect");
    resetForm(props.nodesHash[props.match.params.id])
  });

  const resetForm = (anchor) => {
    if (anchor) {
      console.log("set editForm " + anchor.hardware_id);
      setId(props.match.params.id);
      setAnchor(anchor);
      setConfig({
        anchor:  anchor.name,
        hardware_id: anchor.hardware_id,
        nid: anchor.configs.anchor.nid,
        channel: anchor.configs.anchor.channel,
        mcs: anchor.configs.anchor.mcs,
        nss: anchor.configs.anchor.nss,
        obw: anchor.configs.anchor.obw,
        payload_length: anchor.configs.anchor.payload_length,
        tx_power: anchor.configs.anchor.tx_power,
        mode: anchor.configs.anchor.mode,
        npkt: anchor.configs.anchor.npkt,
        anch_alarm: anchor.configs.anchor.anch_alarm,
        anch_heartbeat: anchor.configs.anchor.anch_heartbeat,
        burst_timeout: anchor.configs.anchor.anch_heartbeat,
        loc_min_anch: anchor.configs.anchor.loc_min_anch,
        loc_max_anch: anchor.configs.anchor.loc_max_anch,
        addr: anchor.configs.anchor.addr,
        name: anchor.configs.anchor.name,
      });

      // Load MAVS2 config if it exists
      const hasMavs2Data = anchor.configs && anchor.configs.mavs2;
      setHasMavs2(hasMavs2Data);
      if (hasMavs2Data) {
        setMavs2Config({
          mavs2_addr: anchor.configs.mavs2.addr || "",
          mavs2_nid: anchor.configs.mavs2.nid || "",
          mavs2_channel: anchor.configs.mavs2.channel || "",
          mavs2_mcs: anchor.configs.mavs2.mcs || "",
          mavs2_nss: anchor.configs.mavs2.nss || "",
          mavs2_obw: anchor.configs.mavs2.obw || "",
          mavs2_payload_length: anchor.configs.mavs2.payload_length || "",
          mavs2_tx_power: anchor.configs.mavs2.tx_power || "",
          mavs2_mode: anchor.configs.mavs2.mode || "",
          mavs2_npkt: anchor.configs.mavs2.npkt || "",
          mavs2_anch_alarm: anchor.configs.mavs2.anch_alarm || "",
          mavs2_anch_heartbeat: anchor.configs.mavs2.anch_heartbeat || "",
          mavs2_burst_timeout: anchor.configs.mavs2.burst_timeout || "",
          mavs2_loc_min_anch: anchor.configs.mavs2.loc_min_anch || "",
          mavs2_loc_max_anch: anchor.configs.mavs2.loc_max_anch || "",
          mavs2_name: anchor.configs.mavs2.name || "",
        });
      }
    }
    setError(ANCHOR_PROPS);
  }

  const validateFields = () => {
    let errorNew = {...ANCHOR_PROPS};
    isNumber("nid", config.nid, errorNew);
    isNumber("channel", config.channel, errorNew);
    isNumber("mcs", config.mcs, errorNew);
    isNumber("nss", config.nss, errorNew);
    isNumber("obw", config.obw, errorNew);
    isNumber("payload_length", config.payload_length, errorNew);
    isNumber("tx_power", config.tx_power, errorNew);
    isNumber("npkt", config.npkt, errorNew);
    isNumber("anch_alarm", config.anch_alarm, errorNew);
    isNumber("anch_heartbeat", config.anch_heartbeat, errorNew);
    isNumber("burst_timeout", config.burst_timeout, errorNew);
    isNumber("loc_min_anch", config.loc_min_anch, errorNew);
    isNumber("loc_max_anch", config.loc_max_anch, errorNew);
    isEmpty("mode", config.mode, errorNew);
    isEmpty("addr", config.addr, errorNew);
    isEmpty("name", config.name, errorNew);

    // Validate MAVS2 fields if enabled
    if (hasMavs2) {
      if (!mavs2Config.mavs2_addr || mavs2Config.mavs2_addr.trim() === '') {
        errorNew.validate = false;
        alert('MAVS2 MAC Address is required when MAVS2 is enabled');
        console.error('MAVS2 validation failed: addr is empty');
      } else {
        // Validate MAC address format (AA:BB:CC:DD:EE:FF or AABBCCDDEEFF)
        const macWithColons = /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/;
        const macWithoutColons = /^[0-9A-Fa-f]{12}$/;
        if (!macWithColons.test(mavs2Config.mavs2_addr) && !macWithoutColons.test(mavs2Config.mavs2_addr)) {
          errorNew.validate = false;
          alert('MAVS2 MAC Address must be in format AA:BB:CC:DD:EE:FF or AABBCCDDEEFF');
          console.error('MAVS2 validation failed: invalid MAC format');
        }
      }
    }

    setError(errorNew);

    return errorNew.validate
  };

  const handleSubmit = (e)=> {
    if (!validateFields()) { return; }

    console.log("submit");
    setDisable_save(true);

    let node = {
      node: {
        name: config.anchor,
        configs: {
          anchor: {
            nid: config.nid,
            channel: config.channel,
            mcs: config.mcs,
            nss: config.nss,
            obw: config.obw,
            payload_length: config.payload_length,
            tx_power: config.tx_power,
            mode: config.mode,
            npkt: config.npkt,
            anch_alarm: config.anch_alarm,
            anch_heartbeat: config.anch_heartbeat,
            burst_timeout: config.burst_timeout,
            loc_min_anch: config.loc_min_anch,
            loc_max_anch: config.loc_max_anch,
            addr: config.addr,
            name: config.name
          }
        }
      }
    };

    // Add or remove MAVS2 config based on checkbox state
    if (hasMavs2) {
      node.node.configs.mavs2 = {
        addr: mavs2Config.mavs2_addr,
        nid: parseInt(mavs2Config.mavs2_nid) || mavs2Config.mavs2_nid,
        channel: parseInt(mavs2Config.mavs2_channel) || mavs2Config.mavs2_channel,
        mcs: parseInt(mavs2Config.mavs2_mcs) || mavs2Config.mavs2_mcs,
        nss: parseInt(mavs2Config.mavs2_nss) || mavs2Config.mavs2_nss,
        obw: parseInt(mavs2Config.mavs2_obw) || mavs2Config.mavs2_obw,
        payload_length: parseInt(mavs2Config.mavs2_payload_length) || mavs2Config.mavs2_payload_length,
        tx_power: parseInt(mavs2Config.mavs2_tx_power) || mavs2Config.mavs2_tx_power,
        mode: mavs2Config.mavs2_mode,
        npkt: parseInt(mavs2Config.mavs2_npkt) || mavs2Config.mavs2_npkt,
        anch_alarm: parseInt(mavs2Config.mavs2_anch_alarm) || mavs2Config.mavs2_anch_alarm,
        anch_heartbeat: parseInt(mavs2Config.mavs2_anch_heartbeat) || mavs2Config.mavs2_anch_heartbeat,
        burst_timeout: parseInt(mavs2Config.mavs2_burst_timeout) || mavs2Config.mavs2_burst_timeout,
        loc_min_anch: parseInt(mavs2Config.mavs2_loc_min_anch) || mavs2Config.mavs2_loc_min_anch,
        loc_max_anch: parseInt(mavs2Config.mavs2_loc_max_anch) || mavs2Config.mavs2_loc_max_anch,
        name: mavs2Config.mavs2_name
      };
      console.log("MAVS2 config being submitted:", node.node.configs.mavs2);
    } else if (anchor.configs && anchor.configs.mavs2) {
      // If MAVS2 was previously enabled but is now disabled, explicitly remove it
      node.node.configs.mavs2 = null;
      console.log("MAVS2 config being removed (set to null)");
    }

    console.log("Node update payload:", JSON.stringify(node, null, 2));
    props.dispatch(updateNode(anchor.node, node));
    setError(Object.assign({}, error, {status: "Saving anchor configs... "}))
    setTimeout(()=>props.dispatch(fetchNodes()), 1000);
    setTimeout(()=>props.history.push(URL), 1500);
  };

  const updateField = (field, e) => {
    setConfig(Object.assign({}, config, {[field]: e.target.value}));
  }

  const updateMavs2Field = (field, e) => {
    setMavs2Config(Object.assign({}, mavs2Config, {[field]: e.target.value}));
  }

  const toggleMavs2 = (e) => {
    setHasMavs2(e.target.checked);
    // If enabling MAVS2 for the first time, copy some values from anchor config
    if (e.target.checked && !mavs2Config.mavs2_addr) {
      setMavs2Config({
        ...mavs2Config,
        mavs2_nid: config.nid,
        mavs2_channel: config.channel,
        mavs2_mode: config.mode,
        mavs2_mcs: config.mcs,
        mavs2_nss: config.nss,
        mavs2_obw: config.obw,
        mavs2_payload_length: config.payload_length,
        mavs2_tx_power: config.tx_power,
        mavs2_npkt: config.npkt,
        mavs2_anch_alarm: config.anch_alarm,
        mavs2_anch_heartbeat: config.anch_heartbeat,
        mavs2_burst_timeout: config.burst_timeout,
        mavs2_loc_min_anch: config.loc_min_anch,
        mavs2_loc_max_anch: config.loc_max_anch,
      });
    }
  }

  const handleCalibrate = (e) => {
    let err = {...error};
    err['status'] = "Anchor - " + anchor.name +  " calibrating...";
    setError(err)

    setTimeout(() => {
      props.dispatch(fetchNode(anchor.node));
      err['status'] = "Anchor - " + anchor.name + " calibrated";
      setError(err)
    }, 10000);
  }

  // Build network interfaces display (IP + MAC addresses)
  const networkInterfaces = getAllNetworkInterfaces(anchor);
  const networkInfo = networkInterfaces.reduce((acc, iface, index) => {
    const prefix = index === 0 ? "" : ` (${iface.interface})`;

    // Add IP address
    acc[`IP Address${prefix}`] = iface.address;

    // Add MAC address if available
    if (iface.mac) {
      acc[`MAC Address${prefix}`] = iface.mac;
    }

    return acc;
  }, {});

  const INFO1 = {
    "Device Name" : get(anchor, "name"),
    "Hardware ID(Mac Address)": get(anchor, 'hardware_id'),
    "System Id": get(anchor, 'node'),
    "Internal Mac Address": get(anchor, 'configs.anchor.addr'),
    ...(get(anchor, 'configs.mavs2.addr') && {
      "MAVS2 Mac Address": get(anchor, 'configs.mavs2.addr')
    }),
    ...networkInfo,  // Spread all network interfaces (IP + MAC)
    "Firmware Version": get(anchor, 'events.system.versions.radio_firmware'),
  }

  const INFO2 = {
    "Calibration Timestamp": anchor && anchor.configs.lps_control && anchor.configs.lps_control.cal ? new Date(anchor.configs.lps_control.cal.timestamp).toString() : "Not Calibrated",
  }

  return(
    <div className="main edit">
      <Link to={"/dashboard/settings/devices/anchor_config"}><i className="fa fa-chevron-left fa-lg back"/></Link>
      <h3>Edit Anchor Config</h3>
      <HeaderContainer
        node = {anchor && anchor.node}
        name = {anchor && anchor.name}
        handleCalibrate = {handleCalibrate}
        type = "anchor"
      />
      <div className="status">{error && error.status}</div>
      <div className="line"/>
      <div className="edit_container">
        <div key="edit">
          <LabelContainer
            labels = {
              {
                "internal_mac" : {"help": "addr", "desc": ""},
                "nid" : {"help": "nid", "desc": ""},
                "channel" : {"help": "channel", "desc": ""},
                "mcs" : {"help": "mcs", "desc": ""},
                "nss" : {"help": "nss", "desc": ""},
                "obw" : {"help": "obw", "desc": ""},
                "payload_length" : {"help": "payload", "desc": ""},
                "tx_power" : {"help": "tx_power", "desc": ""},
                "mode" : {"help": "mode", "desc": ""},
                "npkt" : {"help": "npkt", "desc": ""},
                "anch_alarm" : {"help": "anch alarm", "desc": ""},
                "anch_heartbeat" : {"help": "anch heartbeat", "desc": ""},
                "burst_timeout" : {"help": "burst timeout", "desc": ""},
                "loc_min_anch" : {"help": "min anch needed for anchor locate", "desc": ""},
                "loc_max_anch" : {"help": "max anch needed for anchor locate", "desc": ""},
                "internal_name" : {"help": "internal tracker name", "desc": ""}
              }
          }/>
          <FormContainer
            fields = {{
                "addr" : {"value": config.addr, "placeholder": "", "error": error.addr},
                "nid" : {"value": config.nid, "placeholder": "", "error": error.nid},
                "channel" : {"value": config.channel, "placeholder": "", "error": error.channel},
                "mcs" : {"value": config.mcs, "placeholder": "", "error": error.mcs},
                "nss" : {"value": config.nss, "placeholder": "", "error": error.nss},
                "obw" : {"value": config.obw, "placeholder": "", "error": error.obw},
                "payload_length" : {"value": config.payload_length, "placeholder": "", "error": error.payload_length},
                "tx_power" : {"value": config.tx_power, "placeholder": "", "error": error.tx_power},
                "mode" : {"value": config.mode, "placeholder": "", "error": error.mode},
                "npkt" : {"value": config.npkt, "placeholder": "", "error": error.npkt},
                "anch_alarm" : {"value": config.anch_alarm, "placeholder": "", "error": error.anch_alarm},
                "anch_heartbeat" : {"value": config.anch_heartbeat, "placeholder": "", "error": error.anch_heartbeat},
                "burst_timeout" : {"value": config.burst_timeout, "placeholder": "", "error": error.burst_timeout},
                "loc_min_anch" : {"value": config.loc_min_anch, "placeholder": "", "error": error.loc_min_anch},
                "loc_max_anch" : {"value": config.loc_max_anch, "placeholder": "", "error": error.loc_max_anch},
                "name" : {"value": config.name, "placeholder": "", "error": error.name}
            }}
            updateField={updateField}
          />
          <InfoContainer
            info={checkACL(props.acl, 'Calibration Field') ? {...INFO1, ...INFO2} : INFO1}
          />
        </div>

        {/* MAVS2 Configuration Section */}
        <div key="mavs2-config" style={{marginTop: '30px'}}>
          <h4 style={{marginBottom: '15px'}}>
            <label>
              <input
                type="checkbox"
                checked={hasMavs2}
                onChange={toggleMavs2}
                style={{marginRight: '10px'}}
              />
              Enable Dual-Radio (MAVS2) Configuration
            </label>
          </h4>

          {hasMavs2 && (
            <>
              <div className="line"/>
              <LabelContainer
                labels = {
                  {
                    "mavs2_mac" : {"help": "MAVS2 MAC Address", "desc": ""},
                    "mavs2_nid" : {"help": "MAVS2 nid", "desc": ""},
                    "mavs2_channel" : {"help": "MAVS2 channel", "desc": ""},
                    "mavs2_mcs" : {"help": "MAVS2 mcs", "desc": ""},
                    "mavs2_nss" : {"help": "MAVS2 nss", "desc": ""},
                    "mavs2_obw" : {"help": "MAVS2 obw", "desc": ""},
                    "mavs2_payload_length" : {"help": "MAVS2 payload", "desc": ""},
                    "mavs2_tx_power" : {"help": "MAVS2 tx_power", "desc": ""},
                    "mavs2_mode" : {"help": "MAVS2 mode", "desc": ""},
                    "mavs2_npkt" : {"help": "MAVS2 npkt", "desc": ""},
                    "mavs2_anch_alarm" : {"help": "MAVS2 anch alarm", "desc": ""},
                    "mavs2_anch_heartbeat" : {"help": "MAVS2 anch heartbeat", "desc": ""},
                    "mavs2_burst_timeout" : {"help": "MAVS2 burst timeout", "desc": ""},
                    "mavs2_loc_min_anch" : {"help": "MAVS2 min anch", "desc": ""},
                    "mavs2_loc_max_anch" : {"help": "MAVS2 max anch", "desc": ""},
                    "mavs2_name" : {"help": "MAVS2 internal name", "desc": ""}
                  }
              }/>
              <FormContainer
                fields = {{
                    "mavs2_addr" : {"value": mavs2Config.mavs2_addr, "placeholder": "AA:BB:CC:DD:EE:FF", "error": ""},
                    "mavs2_nid" : {"value": mavs2Config.mavs2_nid, "placeholder": "", "error": ""},
                    "mavs2_channel" : {"value": mavs2Config.mavs2_channel, "placeholder": "", "error": ""},
                    "mavs2_mcs" : {"value": mavs2Config.mavs2_mcs, "placeholder": "", "error": ""},
                    "mavs2_nss" : {"value": mavs2Config.mavs2_nss, "placeholder": "", "error": ""},
                    "mavs2_obw" : {"value": mavs2Config.mavs2_obw, "placeholder": "", "error": ""},
                    "mavs2_payload_length" : {"value": mavs2Config.mavs2_payload_length, "placeholder": "", "error": ""},
                    "mavs2_tx_power" : {"value": mavs2Config.mavs2_tx_power, "placeholder": "", "error": ""},
                    "mavs2_mode" : {"value": mavs2Config.mavs2_mode, "placeholder": "", "error": ""},
                    "mavs2_npkt" : {"value": mavs2Config.mavs2_npkt, "placeholder": "", "error": ""},
                    "mavs2_anch_alarm" : {"value": mavs2Config.mavs2_anch_alarm, "placeholder": "", "error": ""},
                    "mavs2_anch_heartbeat" : {"value": mavs2Config.mavs2_anch_heartbeat, "placeholder": "", "error": ""},
                    "mavs2_burst_timeout" : {"value": mavs2Config.mavs2_burst_timeout, "placeholder": "", "error": ""},
                    "mavs2_loc_min_anch" : {"value": mavs2Config.mavs2_loc_min_anch, "placeholder": "", "error": ""},
                    "mavs2_loc_max_anch" : {"value": mavs2Config.mavs2_loc_max_anch, "placeholder": "", "error": ""},
                    "mavs2_name" : {"value": mavs2Config.mavs2_name, "placeholder": "", "error": ""}
                }}
                updateField={updateMavs2Field}
              />
              <div style={{padding: '10px', backgroundColor: '#f0f8ff', borderLeft: '4px solid #4CAF50', marginTop: '10px'}}>
                <p><strong>Note:</strong> Enter the MAVS2 MAC address from the device logs.</p>
                <p>Example format: <code>AABBCCDDEEFF</code> → <code>AA:BB:CC:DD:EE:FF</code> (with colons)</p>
              </div>
            </>
          )}
        </div>
      </div>
      <div>
        <Link to={URL}><button className="cancel">Cancel</button></Link>
        <span id="save"><button className="save" disabled={disable_save} onClick={e => handleSubmit()}>Save</button></span>
      </div>
    </div>
  );
}

export default connect (
  state => ({
      nodesHash: getNodesHash(state),
      acl: state.user.acl,
    }),
)(EditAnchorConfig);
